import type { OpsOverview, OpsQueue } from '@nucleus-commerce/api-client/platform';

/** Outbox events older than this mean the worker is behind or down. */
export const OUTBOX_LAG_WARN_SECONDS = 60;
/** No rollup for this long means the nightly job missed a run. */
export const ROLLUP_STALE_MS = 26 * 60 * 60_000;

export type Tone = 'success' | 'warning' | 'destructive';

export function queueTone(queue: OpsQueue): Tone {
  if (queue.failed > 0) return 'destructive';
  if (queue.waiting + queue.delayed > 0) return 'warning';
  return 'success';
}

export function outboxTone(outbox: OpsOverview['outbox']): Tone {
  if (outbox.lagSeconds >= 10 * OUTBOX_LAG_WARN_SECONDS) return 'destructive';
  return outbox.lagSeconds >= OUTBOX_LAG_WARN_SECONDS ? 'warning' : 'success';
}

export function rollupTone(lastRollupAt: string | null, now: number): Tone {
  if (lastRollupAt === null) return 'warning';
  return now - Date.parse(lastRollupAt) > ROLLUP_STALE_MS ? 'warning' : 'success';
}

/** Seconds as "4 min 0 s" pieces for an i18n string; whole minutes past an hour. */
export function lagParts(seconds: number): { hours: number; minutes: number; seconds: number } {
  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}
